(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmuly-email-offer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-dmuly-offer]').forEach(dialog => {
 const preview = new URLSearchParams(location.search).get('offer_preview') === '1';
 if (dialog.dataset.enabled !== 'true' && !preview) return;
 const key='dmuly-offer-dismissed';
 const success=!!dialog.querySelector('[data-offer-success]');
 const response=success||!!dialog.querySelector('[data-offer-errors]');
 let subscribed=false;try{subscribed=localStorage.getItem('dmuly-offer-subscribed')==='true';if(success)localStorage.setItem('dmuly-offer-subscribed','true');}catch{}
 if(subscribed&&!response&&!preview)return;
 const close=()=>{dialog.close();if(!preview){try{localStorage.setItem(key,String(Date.now()));}catch{}}};
 dialog.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',close));
 dialog.addEventListener('cancel',()=>{if(!preview){try{localStorage.setItem(key,String(Date.now()));}catch{}}});
 let dismissed=0;try{dismissed=Number(localStorage.getItem(key)||0);}catch{}
 if(!preview&&!response&&Date.now()-dismissed<7*86400000)return;
 let enquiryStarted=location.hash.toLowerCase()==='#contact';
 let timer;
 const suppress=()=>{enquiryStarted=true;clearTimeout(timer);};
 const contactLink=event=>{
  const link=event.target.closest?.('a[href]');
  if(!link)return;
  const destination=new URL(link.href,location.href);
  if(destination.origin===location.origin&&destination.pathname===location.pathname&&destination.hash.toLowerCase()==='#contact')suppress();
 };
 document.addEventListener('click',contactLink);
 window.addEventListener('hashchange',()=>{if(location.hash.toLowerCase()==='#contact')suppress();});
 document.querySelectorAll('[data-quote-form]').forEach(form=>{
  ['focusin','input','change','pointerdown','submit'].forEach(type=>form.addEventListener(type,suppress));
 });
 timer=setTimeout(()=>{
  if(!response&&(enquiryStarted||location.hash.toLowerCase()==='#contact'||document.activeElement?.closest('[data-quote-form]')))return;
  if(!document.querySelector('dialog[open]'))dialog.showModal();
 },preview||response?0:8000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmuly-navigation"] && !Shopify.designMode) return;
  try {
    
  const dmulyHeaderGroup = document.getElementById('header-group');
  if (dmulyHeaderGroup) {
    const updateDmulyHeaderHeight = () => {
      document.documentElement.style.setProperty('--dmuly-sticky-height', `${dmulyHeaderGroup.getBoundingClientRect().height}px`);
    };
    new ResizeObserver(updateDmulyHeaderHeight).observe(dmulyHeaderGroup);
    updateDmulyHeaderHeight();
  }

  const dmulyScrollToSection = (hash, behavior = 'smooth') => {
    const anchor = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!anchor || !anchor.classList.contains('dmuly-anchor')) return false;
    const section = anchor.closest('.shopify-section')?.nextElementSibling;
    const heading = section?.querySelector('h1, h2, h3');
    const destination = section?.querySelector('.dmuly-work__intro') || heading || section || anchor;
    const headerHeight = dmulyHeaderGroup?.getBoundingClientRect().height || 0;
    destination.style.scrollMarginTop = `${headerHeight + 24}px`;
    destination.scrollIntoView({ block: 'start', inline: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior });
    return true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || (event.button != null && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
    if (!dmulyScrollToSection(url.hash)) return;
    event.preventDefault();
    if (window.location.hash !== url.hash) history.pushState(null, '', url.hash);
  });
  window.addEventListener('hashchange', () => dmulyScrollToSection(window.location.hash));
  const dmulyAlignInitialHash = () => {
    if (window.location.hash) dmulyScrollToSection(window.location.hash, 'auto');
  };
  if (document.readyState === 'complete') dmulyAlignInitialHash();
  else window.addEventListener('load', dmulyAlignInitialHash, { once: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmuly-smart-quote"] && !Shopify.designMode) return;
  try {
    
 document.querySelectorAll('[data-quote-form]').forEach(root => {
   const project = root.querySelector('[data-project]');
   if (!project) return;
   const toggle = (group, visible) => {
     group.hidden = !visible;
     group.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !visible; });
   };
   const update = () => {
     const choice = project.value;
     toggle(root.querySelector('[data-followup]'), Boolean(choice));
     root.querySelectorAll('[data-branch]').forEach(group => toggle(group, Boolean(choice) && group.dataset.branch.split(' ').includes(choice)));
     const access = root.querySelector('[data-access]');
     toggle(root.querySelector('[data-access-detail]'), !access.disabled && ['height','stairs','unsure'].includes(access.value));
     const timing = root.querySelector('[data-timing]');
     toggle(root.querySelector('[data-deadline]'), !timing.disabled && timing.value === 'date');
     root.querySelector('[data-branch-status]').textContent = choice ? project.options[project.selectedIndex].textContent : '';
   };
   const quoteChoices = {
     'school mural quote': 'school',
     'commercial mural quote': 'business',
     'residential mural quote': 'home'
   };
   document.addEventListener('click', event => {
     const link = event.target.closest('a[href]');
     if (!link || link.hash !== '#contact') return;
     const choice = quoteChoices[link.textContent.trim().toLowerCase()];
     if (!choice) return;
     project.value = choice;
     project.dispatchEvent(new Event('change', { bubbles: true }));
   });
   root.addEventListener('change', update);
   update();
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
